import {
  Breadcrumb,
  Form,
  Row,
  Col,
  Select,
  DatePicker,
  Input,
  PageHeader,
  Popconfirm,
  Button,
  Spin,
  message,
  InputNumber,
} from "antd";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import React, { useState, useEffect } from "react";
import { CreditType } from "_helpers";
import { currencyService, stockIssueService, guranteeService } from "_services";
import { creditVoucherService } from "_services/creditvoucher.service";

function Add({ history }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [currencyTypes, setCurrencyTypes] = useState([]);
  const [stockIssues, setStockIssues] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllCurrencyTypes();
    getAllStockIssues();
  }, []);

  const getAllStockIssues = () => {
    setLoading(true);
    stockIssueService
      .getAll()
      .then((data) => {
        setStockIssues(data.content);
        setLoading(false);
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
        setError(error);
      });
  };

  const getAllCurrencyTypes = () => {
    currencyService.getSuggestion().then((data) => {
      setCurrencyTypes(data.content);
    });
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);

        creditVoucherService
          .create(values)
          .then((response) => {
            setLoading(false);
            message.success("Successfully Updated!");
          })
          .catch((error) => {
            message.error(error);
            setLoading(false);
          });
      })
      .catch((error) => message.error(error));
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Popconfirm
        title="Are you sure?"
        onConfirm={(e) => {
          handleFormSubmit();
        }}
        key="save-confirm"
      >
        <Button key="btn-save" type="primary" htmlType="submit">
          Save
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button
        key="btn-cancel"
        htmlType="button"
        onClick={() => history.push(".")}
      >
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Hierarchy</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/credit-vouchers">Credit-Vouchers</Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/credit-vouchers/Add">Add</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form"
              requiredMark={true}
              onFinish={handleFormSubmit}
              initialValues={{ creditType: "VOUCHER" }}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["customsRefNumber"]}
                    label="Export Cus.Dec.No#"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["voucherNumber"]}
                    label="Voucher Number"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name={["receivedDate"]} label="Received Date">
                    <DatePicker
                      placeholder="Received Date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["currency", "name"]}
                    label="Currency"
                    rules={[{ required: true, message: "Currency Required" }]}
                  >
                    <Select
                      onChange={(selected, option) =>
                        form.setFieldValue(["currency", "id"], option.key)
                      }
                    >
                      {currencyTypes?.map((type) => (
                        <Select.Option value={type.name} key={type.id}>
                          {type.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["creditAmount"]}
                    label="Credit Amount"
                    rules={[
                      { required: true, message: "Credit Amount Required" },
                    ]}
                  >
                    {/* <InputNumber
                      style={{ width: "100%" }}
                      min={1}
                      max={99999999999999999999999999}
                      step={1}
                      formatter={(value) =>
                        value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/,/g, "")}
                      type="number"
                      placeholder="Credit Amount"
                    /> */}

                    <Input type="number"></Input>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["creditType"]}
                    label="Credit Type"
                    rules={[{ required: true, message: "Tiep Type Required" }]}
                    hidden
                  >
                    <Select hidden>
                      {CreditType.map((type) => (
                        <Select.Option value={type.value} key={type.value}>
                          {type.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item name={["currency", "id"]}>
                    <Input hidden></Input>
                  </Form.Item>
                </Col>

                <Col>
                  <Form.Item name={["stockIssue", "id"]}>
                    <Input hidden></Input>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
